<div class="voltar" (click)="voltar()">
  <img src="assets/icons/arrow-back.svg" />
  <span>Voltar</span>
</div>
